import {FlashCircle, Trash} from 'iconsax-react-native';
import React, {useRef} from 'react';
import {View} from 'react-native';
import BaseText from '../../BaseText';
import BaseButton from '../../Button/BaseButton';
import {
  convertToPersianTimeLabel,
  formatNumber,
} from '../../../utils/helpers/helpers';
import {CartItem} from '../../../utils/helpers/CartStorage';
import {useTranslation} from 'react-i18next';
import BottomSheet, {BottomSheetMethods} from '../../BottomSheet/BottomSheet';
import {useCartContext} from '../../../utils/CartContext';
import CreditSubProduct from '../SubProduct';
import CartExpiryNotice from './CartExpiryNotice';
import {useDefaultCartItemRemainingTime} from '../../../utils/hooks/useDefaultCartItemRemainingTime';
type CartCreditCardProps = {
  data: CartItem;
};
const CartCreditCard: React.FC<CartCreditCardProps> = ({data}) => {
  const {t} = useTranslation('translation', {keyPrefix: 'Cart'});
  const {product, quantity, CartId} = data;
  const {updateItemQuantity, removeFromCart} = useCartContext();
  const RemoveItemRef = useRef<BottomSheetMethods>(null);
  const remainingMinutes = useDefaultCartItemRemainingTime(data);
  return (
    <>
      <BottomSheet
        Title={t('Confirm removal')}
        ref={RemoveItemRef}
        snapPoints={[30]}
        buttonText="لغو"
        onButtonPress={() => RemoveItemRef.current?.close()}
        deleteButtonText="حذف"
        onDeleteButtonPress={() => {
          removeFromCart(CartId!);
          RemoveItemRef.current?.close();
        }}
      />

      <View className="CardBase">
        <View className="flex-row items-center justify-between gap-2">
          <View className="flex-row flex-1 items-center gap-2">
            <FlashCircle size="24" color="#fed376" variant="Bold" />
            <BaseText
              type="subtitle2"
              color="supportive1"
              className="flex-1 line-clamp-1 truncate">
              {product.title}
            </BaseText>
          </View>
          <BaseButton
            noText
            onPress={() => RemoveItemRef.current?.expand()}
            type="Tonal"
            color="Black"
            LeftIcon={Trash}
            redbutton
          />
        </View>
        <View className="flex-row items-center justify-between gap-2 border-b border-neutral-0 dark:border-neutral-dark-400/50 pb-4">
          <View className="flex-row items-center gap-4 ">
            <BaseButton
              onPress={() => {
                updateItemQuantity({cartId: CartId!, quantity: quantity + 1});
              }}
              type="Tonal"
              color="Black"
              text="+"
            />
            <BaseText type="subtitle2" color="base">
              {quantity}
            </BaseText>
            <BaseButton
              type="Tonal"
              color="Black"
              text="-"
              onPress={() => {
                updateItemQuantity({
                  cartId: CartId!,
                  quantity: quantity === 1 ? quantity : quantity - 1,
                });
              }}
            />
          </View>
          <BaseText type="subtitle2" color="base">
            {formatNumber(product.price)} ﷼
          </BaseText>
        </View>

        <View className="gap-4">
          <BaseText type="subtitle2" color="secondaryPurple">
            {t('order Detail')}
          </BaseText>
          <View className="gap-3">
            <View className="flex-row items-center justify-between">
              <BaseText type="subtitle3" color="secondary">
                {t('Duration')} :
              </BaseText>
              <BaseText type="subtitle3" color="base">
                {convertToPersianTimeLabel(product.duration)}
              </BaseText>
            </View>
            <BaseText type="subtitle3" color="secondary">
              {t('usedFor')}
            </BaseText>
            <CreditSubProduct
              subProducts={data.product?.subProducts}
              hasSubProduct={data.product?.hasSubProduct}
              inCard
            />
          </View>
        </View>
        <CartExpiryNotice mode="default" remainingMinutes={remainingMinutes} />
      </View>
    </>
  );
};

export default CartCreditCard;
